import * as React from 'react'
import * as Redux from 'react-redux'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as model from '@owl-nest/models'
import * as hooks from '@owl-nest/hooks'
import * as service from '@owl-nest/services'
import * as sharing from '@owl-nest/sharing'
import * as shadow from '@owl-nest/shadow'

import * as projectModel from '../../../../models/project'
import { RootState } from '../../../../../reducers'
import { FollowProjectButton } from '../FollowProjectButton'
import { TRACKING_SOURCE } from '../../utils/trackerEnums'

export function SocialActions() {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const isFailure = model.project.isFinished<projectModel.ExtraFields>(project) && !project.goal_raised
  const [isProjectDetailShareModalOpen, setIsProjectDetailShareModalOpen] = hooks.useModal('ProjectDetailShare')

  const auth = service.user.useAuth()
  const tracking = shadow.useTracking()
  const projectURL = sharing.getSharingURL(
    'project-page',
    'clipboard',
    project,
    auth.type === 'loggedin' ? auth.user : undefined,
  )

  return (
    <>
      <SocialActionsView>
        <ActionButtonWrapper $centeredButton={isFailure}>
          {project.status === api.ProjectStatus.ONLINE && !isFailure && (
            <plume.ActionButton
              onClick={async () => {
                if (navigator.share && plume.utils.isMobile()) {
                  await navigator.share({
                    title: model.project.name(project),
                    url: projectURL,
                  })
                  tracking.social.track({
                    eventCategory: shadow.CATEGORY.PROJECT_PAGE,
                    eventLabel: TRACKING_SOURCE.HERO,
                    socialAction: 'click: Share',
                    socialNetwork: shadow.SOCIAL_NETWORK.NATIVE,
                    socialTarget: project.absolute_url,
                  })
                } else {
                  setIsProjectDetailShareModalOpen(!isProjectDetailShareModalOpen)
                }
              }}
              active={isProjectDetailShareModalOpen}
              contents={{
                inactive: (
                  <>
                    <span>{t('Share')}</span> <plume.glyphs.stroke.Share size={17} />
                  </>
                ),
                active: (
                  <>
                    <span>{t('Share')}</span> <plume.glyphs.stroke.Share size={17} />
                  </>
                ),
              }}
            />
          )}
          <FollowProjectButton source={TRACKING_SOURCE.HERO} />
        </ActionButtonWrapper>
      </SocialActionsView>
    </>
  )
}

const SocialActionsView = styled.div`
  margin-bottom: 25px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 0;
  }
`

const ActionButtonWrapper = styled.div<{ $centeredButton: boolean }>`
  display: flex;
  justify-content: ${({ $centeredButton }) => ($centeredButton ? 'center' : 'space-between')};
  position: relative;

  ${plume.ActionButton} {
    margin-right: 10px;
    width: 100%;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.ActionButton} {
      margin-right: 10px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.ActionButton} {
      margin-left: 4px;
      margin-right: 4px;
      width: 130px;
    }
  }
`
